window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//Plugins
window.$ = window.jQuery = require('jquery');
window.autosize = require('autosize');
window.niceSelect = require('jquery-nice-select');
window.tooltipster = require('tooltipster');
window.Zebra_pin = require('zebra_pin');
window.Swiper = require('swiper/bundle').default;
window.smartmenus = require('smartmenus');
window.Cookies = require('js-cookie');
